import type { ColumnConfig } from '../../../hooks';

/** Default column configuration for the resources table */
export const RESOURCE_DEFAULT_COLUMNS: ColumnConfig[] = [
  { id: 'icon', label: '', visible: true, sortable: false },
  { id: 'title', label: 'Title', visible: true, sortable: false },
  { id: 'category', label: 'Category', visible: true, sortable: false },
  { id: 'sessions', label: 'Sessions', visible: true, sortable: false },
  { id: 'access', label: 'Access', visible: true, sortable: false },
  { id: 'added', label: 'Added', visible: true, sortable: false },
];

/** Get minimum width for a resource column */
export function getResourceColumnMinWidth(columnId: string): number | undefined {
  switch (columnId) {
    case 'icon': return 40;
    case 'title': return 250;
    case 'category': return 120;
    case 'sessions': return 180;
    case 'access': return 200;
    case 'added': return 100;
    default: return 100;
  }
}
